import { render, staticRenderFns } from "./badInfo.vue?vue&type=template&id=ba030eb0&scoped=true"
import script from "./badInfo.vue?vue&type=script&lang=ts"
export * from "./badInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba030eb0",
  null
  
)

export default component.exports